// Module
var code = "<div class=\"organisation__details\">\n    <div class=\"organisation_text organisation_title\">\n        {{ organisation.name }}\n    </div>\n</div>\n";
// Exports
var _module_exports = code;;
var path = 'components/organisation/list/base/ol-item-details.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;